<template>
  <div class="content">
    <div class="content__wrapper">
      <div class="content__title">
        <h1 class="text-maquamarine">{{ title }}</h1>
      </div>

      <div class="content__text w-full text-center">
        <p>
          Retrouvez ici toute l'actualité de Corbet. On parle produits,
          évènements, nouveautés...
        </p>
      </div>

      <div class="content__feed flex flex-row items-start justify-around">
        <div class="feed__entreprise flex flex-col">
          <hr class="divider divider--top" />
          <h2 class="text-center text-nav text-brown">L'entreprise</h2>
          <hr class="divider divider--bot" />
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6742726062003818497" allowfullscreen="" title="Post intégré" width="504" height="584" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_web2print-formations-impression-activity-6742726062637154305-2rUG'
              )
            "
          >
            Voir ce post sur LinkedIn >>
          </a>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6729670772291379200" allowfullscreen="" title="Post intégré" width="504" height="617" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/corbet-imprimerie_imprimerie-corbet-activity-6729670772635316224-obZ3'
              )
            "
          >
            Voir ce post sur LinkedIn >>
          </a>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6709152514387845120"
            allowfullscreen=""
            title="Post intégré"
            height="662"
            frameborder="0"
          ></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_cas-concret-formation-dans-le-sport-gestion-activity-6709152515323174912-CsEp'
              )
            "
          >
            Voir ce post sur LinkedIn >>
          </a>

          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6699257996742062080"
            allowfullscreen=""
            title="Post intégré"
            height="702"
            frameborder="0"
          ></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_corbet-catalogue-covid-activity-6699257997614485504-9j_-'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6674257328210100224"
            allowfullscreen=""
            title="Post intégré"
            height="662"
            frameborder="0"
          ></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_corbet-cas-concret-formation-dans-le-activity-6674257328973463553-b3nn'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >
        </div>

        <div class="feed__produits flex flex-col">
          <hr class="divider divider--top" />
          <h2 class="text-center text-nav text-brown">Produits</h2>
          <hr class="divider divider--bot" />
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6806174924999340032" allowfullscreen="" title="Post intégré" width="504" height="946" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_communicationvisuelle-creativite-services-activity-6806174945278783488-B5vf'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6798281147097907200" allowfullscreen="" title="Post intégré" width="504" height="691" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_services-reprographie-plans-activity-6798281147718647808-jLUA'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6793182326672146432" allowfullscreen="" title="Post intégré" width="504" height="773" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_services-imprimerienumaezrique-communicationvisuelle-activity-6793182329209700352--Gm-'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6773241346141556736" allowfullscreen="" title="Post intégré" width="504" height="826" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_imprimerienumaezrique-gestiondocumentaire-activity-6773242124684070912-Hcy3'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6749345220917260288" allowfullscreen="" title="Post intégré" width="504" height="929" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/yannick-le-moine-technico-commercial-ab3a72162_imprimerie-communication-activity-6749345221743529984-I6Di'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6729340938709192704" allowfullscreen="" title="Post intégré" width="504" height="873" frameborder="0"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_imprimerienumaezrique-gestiondocumentaire-activity-6729340939350941696-CLw1'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6724619751005417472" height="865" width="504" frameborder="0" allowfullscreen="" title="Post intégré"></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/yannick-le-moine-technico-commercial-ab3a72162_imprimerie-imprimerienumaezrique-activity-6724619751689097216-QqF-'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >

          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6691733506860625920"
            allowfullscreen=""
            title="Post intégré"
            height="682"
            frameborder="0"
          ></iframe>
          <a
            class="text-linkedin text-base text-right"
            @click="
              goLinkedIn(
                'https://www.linkedin.com/posts/bruno-jacqueline-7346a387_imprimerienumaezrique-activity-6691733723420909568-PAU-'
              )
            "
            >Voir ce post sur LinkedIn >></a
          >
        </div>
      </div>

      <div id="test"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'ACTUALITÉS'
    }
  },
  methods: {
    goLinkedIn (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="css" scoped>
.content__wrapper {
  padding: 2.5% 5% 1.5%;
}

.divider {
  height: 0.05vw;
  background-color: #990d44;
  width: 70%;
}

.divider--top {
  margin: 0 auto 1.2vw auto;
}

.divider--bot {
  margin: 1.2vw auto 0 auto;
  width: 55%;
}

.content__feed {
  margin-top: 3vw;
}

.feed__produits,
.feed__entreprise {
  flex: 0 1 46%;
}

.feed__produits iframe,
.feed__entreprise iframe {
  margin-top: 1.8vw;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .content {
    margin-left: 10%;
  }
}

@media screen and (max-width: 768px) {
  .content__feed {
    display: block;
  }

  .divider {
    margin: 0 0 1.2vw;
  }

  .divider--bot {
    width: 40%;
  }

  .divider--top {
    display: none;
  }

  .feed__produits iframe,
  .feed__entreprise iframe {
    margin: 4.5vw 0 0;
  }

  .feed__entreprise h2,
  .feed__produits h2 {
    margin: 3vw 0;
    text-align: left;
  }

  h2 {
    font-size: 4.8vw;
  }
  .text-linkedin {
    font-size: 4.4vw;
    margin-bottom: 1.5vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Actualités.vue